export default {
  catInfo: 'category_HLP_Name',
  viewAll: 'category_HLP_ViewAll',
};
